/* eslint-disable @typescript-eslint/no-require-imports */
import type { ExecutorchLlmService } from "$src/core/services/search-classification/types";
import CustomPlatform from "$src/core/utils/platform/platform";

const ExecutorchLlm: ExecutorchLlmService = CustomPlatform.select<
  () => ExecutorchLlmService
>({
  native: () => require("./executorch-llm").default,
  tv: () => require("./executorch-llm.web").default,
  default: () => require("./executorch-llm.web").default,
})();

export default ExecutorchLlm;
